export const PROFORMA_INVOICES = "PROFORMA_INVOICES";
export const INVOICES = "INVOICES";

export const PROFORMA_INVOICES_STATE_KEY = "proInvoices";
export const INVOICES_STATE_KEY = "invoices";
